"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable import/prefer-default-export */

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var media_query_1 = require("../utils/media-query");

var CellWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  flex: ", ";\n  display: ", ";\n  order: ", ";\n  ", ";\n\n  ", ";\n  ", "\n  ", "\n"], ["\n  box-sizing: border-box;\n  flex: ", ";\n  display: ", ";\n  order: ", ";\n  ", ";\n\n  ", ";\n  ", "\n  ", "\n"])), function (p) {
  return p.flex || '0 0 auto';
}, function (p) {
  return p.display || 'block';
}, function (p) {
  return p.order;
}, function (p) {
  return p.alignSelf && "align-self: " + p.alignSelf;
}, function (p) {
  return media_query_1.makeStyledMediaQueryGap('padding', p);
}, function (p) {
  return media_query_1.makeStyledMediaQueryFlexWidth(p);
}, function (p) {
  return media_query_1.makeStyledMediaQueryOffset('margin-left', p);
});

exports.Cell = function (_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  return react_1.default.createElement(CellWrapper, __assign({}, rest), children);
};

CellWrapper.defaultProps = {
  flex: '0 0 auto',
  display: 'block',
  columns: 12
};
var templateObject_1;